import { UserService } from '@/services/user'
import { ApiErrorResponse, ApiIndividualResponse } from '@/types/api'
import { IUser, UserInclude } from '@/types/user'

import { useQuery, UseQueryOptions } from '@tanstack/react-query'

export function getUseMyUserOptions(
  include: UserInclude[] = [],
  options?: Omit<
    UseQueryOptions<ApiIndividualResponse<IUser>, ApiErrorResponse>,
    'queryKey' | 'queryFn'
  >
) {
  return {
    queryKey: [UserService.mePath, ...include],
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      UserService.getMe({ include, options: { signal } }),
    // TODO: reset the workspace id if the current workspace id does not exists in the user workspaces
    ...options,
  }
}

export type UseMyUserArgs = {
  include?: UserInclude[]
  options?: Omit<
    UseQueryOptions<ApiIndividualResponse<IUser>, ApiErrorResponse>,
    'queryKey' | 'queryFn'
  >
}

export function useMyUser({
  include = [UserInclude.Company, UserInclude.Profile, UserInclude.Workspaces],
  options,
}: UseMyUserArgs = {}) {
  return useQuery<ApiIndividualResponse<IUser>, ApiErrorResponse>(
    getUseMyUserOptions(include, options)
  )
}
